import { Tag } from '../../../../@types';
import { PartObject } from '../../../../@types/part.type';
import { AutocompleteTagType } from '../../../../components/organisms/Tags';
import { MainPartEditTouched } from '../../../../components/templates/MainPartEdit';

export const INITIAL_TOUCHED: MainPartEditTouched = {
  serial1: false,
  condition: false,
  configReason: false,
};

/** Stable signature for the current tag selection — order-independent so re-renders don't trigger spurious dirty flips. */
export const tagSignature = (tags: (string | AutocompleteTagType)[], fresh: Tag[]): string => {
  const ids = tags
    .map((t) => (typeof t === 'string' ? `s:${t}` : `t:${t.id ?? ''}:${t.label ?? ''}`))
    .sort()
    .join('|');
  const newSig = fresh
    .map((t) => `n:${t.text ?? ''}`)
    .sort()
    .join('|');
  return `${ids}::${newSig}`;
};

export const isPartFieldDirty = (a: PartObject, b: PartObject): boolean =>
  a.serial1 !== b.serial1 ||
  a.serial2 !== b.serial2 ||
  a.serial3 !== b.serial3 ||
  a.notes !== b.notes ||
  String(a.conditionCode) !== String(b.conditionCode) ||
  String(a.softwareVersionId ?? '') !== String(b.softwareVersionId ?? '') ||
  String(a.hardwareRevisionId ?? '') !== String(b.hardwareRevisionId ?? '') ||
  String(a.firmwareVersionId ?? '') !== String(b.firmwareVersionId ?? '') ||
  String(a.fleetTagId ?? '') !== String(b.fleetTagId ?? '');

/** Configuration-specific dirtiness — drives the conditional "Reason for change" requirement. */
export const isConfigFieldDirty = (a: PartObject, b: PartObject, partTypeId: number): boolean =>
  partTypeId !== b.partTypeId ||
  String(a.softwareVersionId ?? '') !== String(b.softwareVersionId ?? '') ||
  String(a.hardwareRevisionId ?? '') !== String(b.hardwareRevisionId ?? '') ||
  String(a.firmwareVersionId ?? '') !== String(b.firmwareVersionId ?? '') ||
  String(a.fleetTagId ?? '') !== String(b.fleetTagId ?? '');
